import FaqList from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import FaqCategory from "../FaqCategory";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-square-question",
    path: "/admin/faq",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/faqs-categories",
  },
];

export const faqRoutes = () => [
  {
    path: "/admin/faq",
    title: "FAQ Management",
    layout: "admin",
    routeType: "admin",
    component: () => (
      <TabsNavigation title="FAQ Management" tabRoutes={tabRoutes}>
        <FaqList />
      </TabsNavigation>
    ),
  },
  {
    path: "/admin/faqs-categories",
    component: () => (
      <TabsNavigation title="FAQ Management" tabRoutes={tabRoutes}>
        <FaqCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "FAQ Management",
  },
];
